// @flow

import {
  type TrackingFunction,
  type TrackingFunctions,
  createEventTracker,
} from '@zapier/tracking';

const trackingFunctions: TrackingFunctions = createEventTracker();

export const {
  trackEvent,
}: { trackEvent: TrackingFunction } = trackingFunctions;

export default trackingFunctions;
